import { render, staticRenderFns } from "./CbsConstructorFormulaCard.vue?vue&type=template&id=76ce8276&scoped=true"
import script from "./CbsConstructorFormulaCard.vue?vue&type=script&lang=js"
export * from "./CbsConstructorFormulaCard.vue?vue&type=script&lang=js"
import style0 from "./CbsConstructorFormulaCard.vue?vue&type=style&index=0&id=76ce8276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ce8276",
  null
  
)

export default component.exports